<script lang="ts">
	import { appManager } from "../AppManager";
</script>

<svelte:head>
<!-- Required meta tags -->
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

<!-- Site icons -->
<link rel="icon" type="image/png" sizes="32x32" href="{appManager.PublicUrl}icons/favicon-16.png">
<link rel="icon" type="image/png" sizes="16x16" href="{appManager.PublicUrl}icons/favicon-32.png">

<!-- Libs CSS -->
<link rel="stylesheet" href="{appManager.PublicUrl}fonts/Feather/feather.css">
<link rel="stylesheet" href="{appManager.PublicUrl}css/flickity.min.css">
<link rel="stylesheet" href="{appManager.PublicUrl}css/flickity-fade.css">
<link rel="stylesheet" href="{appManager.PublicUrl}css/aos.css">
<link rel="stylesheet" href="{appManager.PublicUrl}css/jarallax.css">
<link rel="stylesheet" href="{appManager.PublicUrl}css/jquery.fancybox.css"> 
<link rel="stylesheet" href="{appManager.PublicUrl}css/theme.css"> 
<link rel="stylesheet" href="{appManager.PublicUrl}css/theme-custom.css"> 
<link rel='stylesheet' href="{appManager.PublicUrl}css/global.css">
<link rel='stylesheet' href="{appManager.PublicUrl}build/bundle.css">
<!-- endbuild -->

<title>ANYWAYS</title>
</svelte:head>
